import { render } from "./TheCode0-9ButtonForm.vue?vue&type=template&id=11377c3b&scoped=true"
import script from "./TheCode0-9ButtonForm.vue?vue&type=script&lang=js"
export * from "./TheCode0-9ButtonForm.vue?vue&type=script&lang=js"

import "./TheCode0-9ButtonForm.vue?vue&type=style&index=0&id=11377c3b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11377c3b"

export default script